import { useState, useCallback } from 'react';
import { get, post, put, del } from '../../utils/networkUtils';

export const usePages = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get all pages
  const fetchPages = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await get('/admin/pages');
      return response.pages ? response.pages.filter(item => item !== null) : [];
    } catch (err) {
      setError(err.message || 'Failed to fetch pages');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Get single page by ID
  const fetchPageById = useCallback(async (pageId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(`/admin/pages/${pageId}`);
      return response.page;
    } catch (err) {
      setError(err.message || 'Failed to fetch page');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Create new page
  const createPage = useCallback(async (pageData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await post('/admin/pages', pageData);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to create page');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Update page
  const updatePage = useCallback(async (pageId, pageData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await put(`/admin/pages/${pageId}`, pageData);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to update page');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Delete page
  const deletePage = useCallback(async (pageId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await del(`/admin/pages/${pageId}`);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to delete page');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchPages,
    fetchPageById,
    createPage,
    updatePage,
    deletePage,
  };
};
